<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">{{ $t("credit analysis") }}</div>

    <!-- Dashboard Statistics Cards -->
    <div class="columns is-multiline mb-5">
      <div class="column is-3">
        <div class="card has-background-dark has-text-white">
          <div class="card-content">
            <div class="level">
              <div class="level-left">
                <div class="level-item">
                  <div>
                    <p class="title is-4 has-text-info">
                      {{ stats.total_requests || 0 }}
                    </p>
                    <p class="subtitle is-6 has-text-white">
                      {{ $t("total requests") }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item">
                  <i class="fa fa-file-alt fa-2x"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-3">
        <div class="card has-background-dark">
          <div class="card-content">
            <div class="level">
              <div class="level-left">
                <div class="level-item">
                  <div>
                    <p class="title is-4 has-text-warning">
                      {{ stats.pending_requests || 0 }}
                    </p>
                    <p class="subtitle is-6 has-text-white">
                      {{ $t("pending requests") }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item">
                  <i class="fa fa-clock fa-2x"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-3">
        <div class="card has-background-dark has-text-white">
          <div class="card-content">
            <div class="level">
              <div class="level-left">
                <div class="level-item">
                  <div>
                    <p class="title is-4 has-text-success">
                      {{ stats.approved_evaluations || 0 }}
                    </p>
                    <p class="subtitle is-6 has-text-white">
                      {{ $t("approved") }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item">
                  <i class="fa fa-check-circle fa-2x"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-3">
        <div class="card has-background-dark has-text-white">
          <div class="card-content">
            <div class="level">
              <div class="level-left">
                <div class="level-item">
                  <div>
                    <p class="title is-4 has-text-white">
                      {{ stats.approval_rate || 0 }}%
                    </p>
                    <p class="subtitle is-6 has-text-white">
                      {{ $t("approval rate") }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item">
                  <i class="fa fa-percentage fa-2x"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Navigation Cards -->
    <div class="grid is-col-min-10">
      <!-- Requests Management Card -->
      <div class="cell" @click="manage_requests">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/4002/4002293.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("credit analysis requests") }}
                </p>
                <p class="subtitle is-6 has-text-centered">
                  {{ $t("manage credit analysis requests") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Evaluations Management Card -->
      <div class="cell" @click="manage_evaluations">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/6341/6341883.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("credit analysis evaluations") }}
                </p>
                <p class="subtitle is-6 has-text-centered">
                  {{ $t("manage credit analysis evaluations") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Reports Card -->
      <!-- <div class="cell" @click="manage_reports">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://www.freeiconspng.com/thumbs/report-icon/call-report-icon-3.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("credit analysis reports") }}
                </p>
                <p class="subtitle is-6 has-text-centered">
                  {{ $t("view reports and statistics") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- Ruleset Management Card -->
      <div class="cell" @click="manage_rulesets">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/2046/2046636.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("ruleset manager") }}
                </p>
                <p class="subtitle is-6 has-text-centered">
                  {{ $t("manage evaluation rulesets") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Settings Card -->
      <!-- <div class="cell" @click="manage_settings">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/900/900834.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("credit analysis settings") }}
                </p>
                <p class="subtitle is-6 has-text-centered">
                  {{ $t("configure module settings") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </section>
</template>

<script>
import { error_message, get } from "@/utils";

export default {
  name: "CreditAnalysisIndex",
  data() {
    return {
      is_loading: false,
      stats: {
        total_requests: 0,
        pending_requests: 0,
        in_progress_requests: 0,
        completed_requests: 0,
        approved_evaluations: 0,
        rejected_evaluations: 0,
        approval_rate: 0,
      },
    };
  },
  methods: {
    manage_requests() {
      this.$router.push({ path: "/credit-analysis/requests" });
    },
    manage_evaluations() {
      this.$router.push({ path: "/credit-analysis/evaluations" });
    },
    manage_reports() {
      this.$router.push({ path: "/credit-analysis/reports" });
    },
    manage_settings() {
      this.$router.push({ path: "/credit-analysis/settings" });
    },
    manage_rulesets() {
      this.$router.push({ path: "/credit-analysis/rulesets" });
    },
    load_stats() {
      let v = this;
      v.is_loading = true;

      get("/credit-analysis/request/stats", {})
        .then((response) => {
          v.stats = response;
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.is_loading = false;
        });
    },
  },
  created() {
    this.load_stats();
  },
  mounted() {
    // Actualizar estadísticas cada 30 segundos
    this.stats_interval = setInterval(() => {
      // If current page is this
      if (this.$route.path === "/credit-analysis") this.load_stats();
    }, 30000);
  },
  beforeDestroy() {
    if (this.stats_interval) {
      clearInterval(this.stats_interval);
    }
  },
};
</script>

<style scoped>
.grid .cell .card:hover {
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}

.grid .cell .card:active {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
}

.grid .cell .card {
  background-color: rgba(20, 22, 26, 0.4);
}

.card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.level {
  margin-bottom: 0;
}
</style>
